import Paths from "router/Paths"
import { PlusSvg, EnvelopSvg, UsersSvg, BuildingSvg, ClockSvg, StatisticsSvg } from "svg"

export default [
	{
		title: "Nowe zgłoszenie",
		svg: <PlusSvg/>,
		path: Paths.Issue.New,
		extra_classes: "add-issue",
		available_for: [ "manage_issues", "manage_all_issues", "manage_own_issues", "manage_all_company_issues", "manage_all" ]
	},
	{
		title: "Zgłoszenia",
		svg: <EnvelopSvg/>,
		path: Paths.Issue.List,
		available_for: [ "manage_issues", "manage_all_issues", "manage_own_issues", "manage_all_company_issues", "manage_all" ]
	},
	{
		title: "Statystyki",
		svg: <StatisticsSvg/>,
		path: Paths.Statistics,
		available_for: [ "manage_all_issues" ]
	},
	{
		title: "Użytkownicy",
		svg: <UsersSvg/>,
		path: Paths.User.List,
		available_for: [ "manage_users", "manage_company_users", "manage_all" ]
	},
	{
		title: "Podwykonawcy",
		svg: <BuildingSvg/>,
		path: Paths.Company.List,
		available_for: [ "manage_all", "manage_companies" ]
	},
   {
	   group_name: "Ustawienia",
	   available_for: [ "manage_all" ]
   },
   {
	  title: "Niedostępność dni",
	  svg: <ClockSvg/>,
	  path: Paths.Settings.UnavailableDays,
	  available_for: [ "manage_all" ]
   }
]